import wrapWith from './private/wrapWith';

export default wrapWith;
